import { useEffect, useState } from "react"
import { useNavigate } from "react-router-dom"
import { observer } from "mobx-react-lite"
import { FloatingButton, HomeHeader, PastEvents, ScanIcon, ScreenContainer, UpcomingEvents } from "../components"
import { EventStore } from "../stores/EventsStore"

export const HomePage = observer(() => {
	const [store] = useState(() => new EventStore())
	const navigate = useNavigate()

	useEffect(() => {
		store.load()
	}, [store])

	return (
		<ScreenContainer>
			<div className="flex min-h-[100%] flex-col items-start">
				<HomeHeader />

				<div className="mt-[35px] w-full">{store.upcomingEvents && <UpcomingEvents events={store.upcomingEvents} />}</div>

				<div className="mt-[60px]">{store.pastEvents && <PastEvents events={store.pastEvents} />}</div>

				<FloatingButton icon={<ScanIcon size={70} opacity={0.9} />} onClick={() => navigate("scan")} />
			</div>
		</ScreenContainer>
	)
})
